<template>
  <div>
    <DDropdown :isShowDots="false" :isBottomStart="false" :propOffset="[5, 5]">
      <button slot="title"
              class="do-bttn"
              :content="$t('vue.deleteday.delete_day_or_week')"
              v-tippy="{
                arrow: true,
                animateFill: false,
                animation : 'shift-away',
                zIndex: '999999992',
                boundary: 'window',
                trigger : 'click'
              }">
        <span class="icon-bin"></span>
        <span class="icon-arrow-down5"></span>
      </button>
      <ul slot="list">
        <li @click="setIsConfirmDeletion('week')" class="d-item-warning">
          {{ $t('vue.deleteday.whole_week') }}
        </li>
        <li v-for="day in weekDays" class="capitalize" @click="setIsConfirmDeletion(day)">
          {{ day.name }}
        </li>
      </ul>
    </DDropdown>
    <transition name="d-modal">
      <ModalConfirmation
        v-if="isConfirmDeletion"
        :showClose="false"
        :isSubmitButtonLoading="isDeleting"
        @close="closeIsConfirmDelete"
        @confirm="onConfirmDelete">
        <h3 slot="item">{{ theDeleteText }}</h3>
      </ModalConfirmation>
    </transition>
  </div>
</template>
<script>
import DDropdown from '../common/DDropdown'
import ModalConfirmation from '../Modals/ModalConfirmation'
import moment from 'moment'
import docendo from '../../docendo'
import eventbus from '../../eventbus'

export default {
  components: {DDropdown, ModalConfirmation},
  props: {
    calendarId: {
      default: null
    },
    firstDayOfTheWeek: {
      default: 1
    },
    date: {
      default: () => moment()
    }
  },
  data () {
    return {
      isConfirmDeletion: false,
      isDeleteWeek: false,
      theDeleteDayDate: null,
      theDeleteText: false,
      isDeleting: false
    }
  },
  computed: {
    weekDays () {
      let arr = []
      for (let i = this.firstDayOfTheWeek; i < 8; i++) {
        const weekDayDate = moment(this.date).isoWeekday(i)
        const obj = {
          date: weekDayDate,
          name: moment(weekDayDate).format('dddd')
        }
        arr.push(obj)
      }
      return arr
    }
  },
  methods: {
    setIsConfirmDeletion (day) {
      if (day === 'week') {
        this.theDeleteText = this.$t('vue2.common.delete') + ' ' + this.$t('vue.deleteday.whole_week')
        this.isDeleteWeek = true
      } else {
        this.isDeleteWeek = false
        this.theDeleteText = this.$t('vue2.common.delete') + ' ' + day.name
        this.theDeleteDayDate = day.date
      }
      this.isConfirmDeletion = true
    },
    closeIsConfirmDelete () {
      this.isConfirmDeletion = false
      this.isDeleteWeek = false
      this.theDeleteDayDate = null
    },
    onConfirmDelete () {
      if (this.isDeleteWeek) {
        this.deleteWeek()
      } else {
        this.deleteDay()
      }
    },
    deleteDay () {
      this.isDeleting = true
      const from = moment(this.theDeleteDayDate).startOf('day').toISOString()
      const to = moment(this.theDeleteDayDate).endOf('day').toISOString()
      docendo.deleteEventsRange(this.calendarId, from, to, success => {
        this.isDeleting = false
        this.closeIsConfirmDelete()
        this.$emit('update')
      }, failure => {
        eventbus.toast = {text: this.$t('vue2.delete_day_or_week.cant_delete'), success: false}
      })
    },
    deleteWeek () {
      this.isDeleting = true
      const fromDate = this.firstDayOfTheWeek === 1 ? moment(this.date).startOf('isoWeek') : moment(this.date).startOf('week')
      const toDate = this.firstDayOfTheWeek === 1 ? moment(this.date).endOf('isoWeek') : moment(this.date).endOf('week')
      const from = moment(fromDate).toISOString()
      const to = moment(toDate).toISOString()
      docendo.deleteEventsRange(this.calendarId, from, to, success => {
        this.isDeleting = false
        this.closeIsConfirmDelete()
        this.$emit('update')
      }, failure => {
        eventbus.toast = {text: this.$t('vue2.delete_day_or_week.cant_delete'), success: false}
      })
    }
  }
}
</script>

<style scoped>
.capitalize {
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// DCalendarHeaderDelete.vue?20799414